import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { makeGetMasterToken } from 'selectors/auth';
import { makeGetCurrentUser } from 'selectors/users';

import { isElectron, isMac } from 'services/env-service';

import SettingsCompact from 'components/settings-compact';
import CurrentUser from 'components/CurrentUser';
import AppUpgradeButton from 'components/AppUpgradeButton';
import AppChangelogButton from 'components/AppChangelogButton';
import AppNav from 'components/AppNav';
import AppSearch from 'components/AppSearch';
import AppHeadCreateButton from 'components/AppHeadCreateButton';
import AppNotificationsToggle from 'components/AppNotificationsToggle';
import WindowsAppControls from 'components/WindowsAppControls';
import MinimizedTasks from 'components/MinimizedTasks';

const APP_BAR_HIDDEN_ROUTES = [/^\/p?signup\//];

class AppBar extends PureComponent {
    state = {
        stack: []
    }

    handleCurrentUserClick = () => {
        this.props.history.push({
            pathname: '/settings/profile',
            state: {
                closeUrl: this.props.history.location.pathname
            }
        });
    }

    componentDidMount() {
        this.props.history.listen(event => {
            const { stack } = this.state;
            if (event.action === 'PUSH') {
                const entry = {
                    route: event,
                    title: 'Nifty',
                    timestamp: Date.now()
                };

                stack.push(entry);

                setTimeout(() => {
                    if (document.title) {
                        entry.title = document.title;
                    }

                    this.setState({
                        stack: [...stack]
                    });
                }, 200);
            }
        });
    }

    render() {
        const { hasMasterToken, hasUser, history } = this.props;

        if (!hasMasterToken || !hasUser || APP_BAR_HIDDEN_ROUTES.some(route => route.test(history.location.pathname))) {
            return null;
        }

        return (
            <div className="app-bar">
                <div className="app-bar-left">
                    <SettingsCompact history={history} />
                </div>

                <div className="app-bar-center">
                    <AppNotificationsToggle />

                    <div className="app-bar-center-inner">
                        <AppNav history={history} />

                        <AppSearch />

                        <MinimizedTasks />
                    </div>
                </div>

                <div className="app-bar-right">
                    <AppHeadCreateButton />

                    <AppUpgradeButton history={history} />

                    {/*<AppChangelogButton />*/}

                    <CurrentUser onClick={this.handleCurrentUserClick} />

                    {
                        isElectron() && !isMac() ? <WindowsAppControls /> : null
                    }
                </div>
            </div>
        )
    }
}

const makeMapStateToProps = () => {
    const getMasterToken = makeGetMasterToken();
    const getCurrentUser = makeGetCurrentUser();

    return ({ auth, users }) => ({
        hasMasterToken: Boolean(getMasterToken(auth)),
        hasUser: Boolean(getCurrentUser(users))
    });
};

export default withRouter(connect(makeMapStateToProps)(AppBar));
